module.exports = __webpack_public_path__ + "img/login.cc527ddf.svg";